export default "__VITE_ASSET__Bh85QDHO__"